import PortalLayout from "@/components/portal/PortalLayout";
import { ChatbotList } from "@/components/portal/ChatbotList";

const PortalChatbots = () => {
  return (
    <PortalLayout>
      <div className="min-h-full bg-slate-950">
        <div className="container mx-auto p-4 md:p-8">
          <ChatbotList />
        </div>
      </div>
    </PortalLayout>
  );
};

export default PortalChatbots;
